import React from 'react';
// import TagManager from 'react-gtm-module';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// const tagManagerArgs = {
//   gtmId: 'GTM-KPDVCFW',
//   auth: '6sBOnZx1hqPcO01xPOytLK',
//   preview: process.env.NODE_ENV === 'production' ? 'env-2' : undefined,
// };

// TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
